export default {
  loading: false,
  error: false,
  TabRdvDispo: [],
}
